const TEAMS_SESSION_KEY = 'cw-ai-teams-session';

/** Remember that this browser tab was opened from the Teams app (survives SSO redirects). */
export function markTeamsSession(): void {
  try {
    sessionStorage.setItem(TEAMS_SESSION_KEY, '1');
  } catch {
    // sessionStorage may be unavailable in rare embed contexts.
  }
}

export function hasTeamsSession(): boolean {
  try {
    return sessionStorage.getItem(TEAMS_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearTeamsSession(): void {
  try {
    sessionStorage.removeItem(TEAMS_SESSION_KEY);
  } catch {
    // ignore
  }
}
